import React from 'react';
export function LiveLabel() {
    return React.createElement("label", { className: "WhSearch-LiveLabel" }, "Live");
}
//# sourceMappingURL=LiveLabel.js.map